import { setErrorDialog, serverUrl, getheader} from "../../../store/api/CommonFunctions";
export function addNewReminder(data, fn) {
    return dispatch => {
        fetch(serverUrl + "api/ReminderAPI/AddNewReminder", {
            headers: getheader(),
            body: JSON.stringify(data),
            method: "POST"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "ثبت یادآوری");
                    return;
                }
                setErrorDialog(dispatch, "success", "ثبت یادآوری");
                if (fn) {
                    fn(res);
                }
            })
    }
}
export function readReminder(id, fn) {
    return dispatch => {
        fetch(serverUrl + "api/ReminderAPI/ReadReminder", {
            headers: getheader(),
            body: id,
            method: "POST"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "ثبت یادآوری");
                    return;
                }
                setErrorDialog(dispatch, "success", "ثبت یادآوری");
                if (fn) {
                    fn(res);
                }
            })
    }
}
export function getReminder(id, fn) {
    return dispatch => {
        fetch(serverUrl + "api/ReminderAPI/GetReminder", {
            headers: getheader(),
            body: id,
            method: "POST"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "دریافت یادآوری");
                    return;
                }
                if (fn) {
                    fn(res);
                }
            })
    }
}
export function deleteReminder(id, fn) {
    return dispatch => {
        fetch(serverUrl + "api/ReminderAPI/DeleteReminder", {
            headers: getheader(),
            body: id,
            method: "POST"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "حذف یادآوری");
                    return;
                }
                setErrorDialog(dispatch, "success", "حذف یادآوری");
                if (fn) {
                    fn(res);
                }
            })
    }
}
export function searchUnreadReminders(skip) {
    let data={};
    data.AlarmDateTo = new Date();
    data.IsRead = false;
    data.Take = 10;
    data.Skip = skip;
    return dispatch => {
        dispatch({
            type: "SEARCH_UNREAD_REMINDERS",
            data: "PENDING"
        });
        fetch(serverUrl + "api/ReminderAPI/SearchReminders", {
            headers: getheader(),
            body: JSON.stringify(data),
            method: "POST"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "دریافت یادآوری ها");
                    res.Data = null;
                }
                dispatch({
                    type: "SEARCH_UNREAD_REMINDERS",
                    data: res
                });
            }).catch(e=> console.log("[SEARCH_UNREAD_REMINDERS]", e))
    }
}
export function searchReminders(data) {
    return dispatch => {
        dispatch({
            type: "SEARCH_REMINDERS",
            data: "PENDING"
        });
        fetch(serverUrl + "api/ReminderAPI/SearchReminders", {
            headers: getheader(),
            body: JSON.stringify(data),
            method: "POST"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "دریافت یادآوری ها");
                    res.Data = null;
                }
                dispatch({
                    type: "SEARCH_REMINDERS",
                    data: res
                });
            }).catch(e => console.log("[SEARCH_REMINDERS]", e))
    }
}
export function setReminderPop(status) {
    return dispatch => {
        return dispatch({
            type: "REMINDER_POP",
            data: status
        });
    }
}
export function getMyRemindersCount(isRead,fn){
        fetch(serverUrl+"api/ReminderAPI/GetMyRemindersCount?isRead="+isRead,{
            headers:getheader(),
            cache:"default",
            method:"GET"
        }).then(res=>res.json())
          .then(res=>{
            if(fn)
            {
                fn(res);
            }
          })
    }